import React from "react";
import { ControlProps } from "react-select";

const HeaderSearchControl: React.FC<ControlProps<any>> = ({ children }) => {
  return <div className="search-control">{children}</div>;
};

export default HeaderSearchControl;
